import {utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import {map} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {useIntl} from 'react-intl';

import stylesAutoLayout from './AutoLayout.less';
import stylesDataChanges from './DataChanges.less';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {ScreenDataHelpers} from 'src/js/model/auto_layout_screen_data_helpers';

const DataChangesItem = ({content, data, isArray, layout}) => {
  const intl = useIntl();
  const formattedValue = ScreenDataHelpers.getValueByContentProperty(
    data,
    content,
    intl,
    isArray
  );
  const label = layout.getLabel()
    ? utils.TranslateUtils.translate(layout.getLabel(), intl)
    : undefined;

  /* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for, react/no-array-index-key */
  return (
    <div
      className={classNames(
        'form-group',
        stylesAutoLayout.dlScreenComponent,
        stylesAutoLayout.dlTextOnly,
        stylesDataChanges.dlDataChangesItem
      )}
    >
      <label className={stylesAutoLayout.dlComponentLabel} title={label}>
        {label || ''}
      </label>
      {isArray ? (
        <div className={stylesAutoLayout.dlScreenComponentInput}>
          {formattedValue.map((formattedValueItem, itemIdx) => (
            <div key={itemIdx}>
              {map(formattedValueItem, (formattedValueItemProperty) => (
                <span
                  key={formattedValueItemProperty.property}
                  className={classNames(
                    stylesAutoLayout.dlScreenComponentInput,
                    stylesAutoLayout.dlDataChangeArrayItem
                  )}
                  title={formattedValueItemProperty.value}
                >
                  {formattedValueItemProperty.value}
                </span>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <span
          className={stylesAutoLayout.dlScreenComponentInput}
          title={formattedValue}
        >
          {formattedValue}
        </span>
      )}
    </div>
  );
  /* eslint-enable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for, react/no-array-index-key */
};

DataChangesItem.propTypes = {
  content: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.instanceOf(ContentProperty),
  ]).isRequired,
  data: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.arrayOf(PropTypes.any),
  ]),
  isArray: PropTypes.bool,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
};

DataChangesItem.defaultProps = {
  data: undefined,
  isArray: false,
};

export default DataChangesItem;
